import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import { CommonEventProperties } from '../../utils/CommonParams'

export const SeeAllButtonClickedEventSchema = (): EventSchema => {
  return {
    eventName: EN.SEE_ALL_BUTTON_CLICKED,
    params: {
      ...CommonEventProperties,
      BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
      EVENT_CATEGORY: EPK.EVENT_CATEGORY,
      BUTTON_TYPE: EPK.BUTTON_TYPE,
      BUTTON_NAME: EPK.BUTTON_NAME,
    },
  }
}
